"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DOUBLE_GUTTERS = 'double';
var GUTTERS = 'gutters';
var THREE_QUARTERS_GUTTERS = 'three-quarters';
var HALF_GUTTERS = 'half';
var QUARTER_GUTTERS = 'quarter';
var DOUBLE_HORIZONTAL_GUTTERS = 'horizontal-double';
var HORIZONTAL_GUTTERS = 'horizontal';
var THREE_QUARTERS_HORIZONTAL_GUTTERS = 'horizontal-three-quarters';
var HALF_HORIZONTAL_GUTTERS = 'horizontal-half';
var QUARTER_HORIZONTAL_GUTTERS = 'horizontal-quarter';
var DOUBLE_VERTICAL_GUTTERS = 'vertical-double';
var VERTICAL_GUTTERS = 'vertical';
var THREE_QUARTERS_VERTICAL_GUTTERS = 'vertical-three-quarters';
var HALF_VERTICAL_GUTTERS = 'vertical-half';
var QUARTER_VERTICAL_GUTTERS = 'vertical-quarter';

function guttersClassName(value) {
  return value === 'gutters' ? 'co-grid--gutters' : 'co-grid--gutters-' + value;
}

var Group = function Group(_ref) {
  var _ref2;

  var children = _ref.children,
      gutters = _ref.gutters,
      horizontalGutters = _ref.horizontalGutters,
      verticalGutters = _ref.verticalGutters,
      fullHeight = _ref.fullHeight,
      props = _objectWithoutProperties(_ref, ["children", "gutters", "horizontalGutters", "verticalGutters", "fullHeight"]);

  var groupClasses = ['co-grid__row', (_ref2 = {}, _defineProperty(_ref2, guttersClassName(gutters), gutters), _defineProperty(_ref2, guttersClassName(horizontalGutters), horizontalGutters), _defineProperty(_ref2, guttersClassName(verticalGutters), verticalGutters), _ref2)];
  var allowedProps = {
    fullHeight: fullHeight
  };
  return _react.default.createElement(_styler.default, {
    classNames: groupClasses,
    modifiers: allowedProps
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
};

Group.DOUBLE_GUTTERS = DOUBLE_GUTTERS;
Group.GUTTERS = GUTTERS;
Group.THREE_QUARTERS_GUTTERS = THREE_QUARTERS_GUTTERS;
Group.HALF_GUTTERS = HALF_GUTTERS;
Group.QUARTER_GUTTERS = QUARTER_GUTTERS;
Group.DOUBLE_HORIZONTAL_GUTTERS = DOUBLE_HORIZONTAL_GUTTERS;
Group.HORIZONTAL_GUTTERS = HORIZONTAL_GUTTERS;
Group.THREE_QUARTERS_HORIZONTAL_GUTTERS = THREE_QUARTERS_HORIZONTAL_GUTTERS;
Group.HALF_HORIZONTAL_GUTTERS = HALF_HORIZONTAL_GUTTERS;
Group.QUARTER_HORIZONTAL_GUTTERS = QUARTER_HORIZONTAL_GUTTERS;
Group.DOUBLE_VERTICAL_GUTTERS = DOUBLE_VERTICAL_GUTTERS;
Group.VERTICAL_GUTTERS = VERTICAL_GUTTERS;
Group.THREE_QUARTERS_VERTICAL_GUTTERS = THREE_QUARTERS_VERTICAL_GUTTERS;
Group.HALF_VERTICAL_GUTTERS = HALF_VERTICAL_GUTTERS;
Group.QUARTER_VERTICAL_GUTTERS = QUARTER_VERTICAL_GUTTERS;
Group.propTypes = {
  /** {---} Sequence of: @@<Grid.Column>@@ (required, min: 1) */
  children: _propTypes.any.isRequired,

  /** {const} One of: @@Grid.Group.GUTTERS@@, @@Grid.Group.DOUBLE_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_GUTTERS@@, @@Grid.Group.HALF_GUTTERS@@, @@Grid.Group.QUARTER_GUTTERS@@ */
  gutters: (0, _propTypes.oneOf)([DOUBLE_GUTTERS, GUTTERS, THREE_QUARTERS_GUTTERS, HALF_GUTTERS, QUARTER_GUTTERS]),

  /** {const} One of: @@Grid.Group.HORIZONTAL_GUTTERS@@, @@Grid.Group.DOUBLE_HORIZONTAL_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_HORIZONTAL_GUTTERS@@, @@Grid.Group.HALF_HORIZONTAL_GUTTERS@@, @@Grid.Group.QUARTER_HORIZONTAL_GUTTERS@@ */
  horizontalGutters: (0, _propTypes.oneOf)([DOUBLE_HORIZONTAL_GUTTERS, HORIZONTAL_GUTTERS, THREE_QUARTERS_HORIZONTAL_GUTTERS, HALF_HORIZONTAL_GUTTERS, QUARTER_HORIZONTAL_GUTTERS]),

  /** {const} One of: @@Grid.Group.VERTICAL_GUTTERS@@, @@Grid.Group.DOUBLE_VERTICAL_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_VERTICAL_GUTTERS@@, @@Grid.Group.HALF_VERTICAL_GUTTERS@@, @@Grid.Group.QUARTER_VERTICAL_GUTTERS@@ */
  verticalGutters: (0, _propTypes.oneOf)([DOUBLE_VERTICAL_GUTTERS, VERTICAL_GUTTERS, THREE_QUARTERS_VERTICAL_GUTTERS, HALF_VERTICAL_GUTTERS, QUARTER_VERTICAL_GUTTERS]),
  fullHeight: _propTypes.bool
};
Group.displayName = 'Grid.Group';
var _default = Group;
exports.default = _default;
Group.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Grid.Group",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Grid.Column>@@ (required, min: 1)"
    },
    "gutters": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'double'",
          "computed": false
        }, {
          "value": "'gutters'",
          "computed": false
        }, {
          "value": "'three-quarters'",
          "computed": false
        }, {
          "value": "'half'",
          "computed": false
        }, {
          "value": "'quarter'",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@Grid.Group.GUTTERS@@, @@Grid.Group.DOUBLE_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_GUTTERS@@, @@Grid.Group.HALF_GUTTERS@@, @@Grid.Group.QUARTER_GUTTERS@@"
    },
    "horizontalGutters": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'horizontal-double'",
          "computed": false
        }, {
          "value": "'horizontal'",
          "computed": false
        }, {
          "value": "'horizontal-three-quarters'",
          "computed": false
        }, {
          "value": "'horizontal-half'",
          "computed": false
        }, {
          "value": "'horizontal-quarter'",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@Grid.Group.HORIZONTAL_GUTTERS@@, @@Grid.Group.DOUBLE_HORIZONTAL_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_HORIZONTAL_GUTTERS@@, @@Grid.Group.HALF_HORIZONTAL_GUTTERS@@, @@Grid.Group.QUARTER_HORIZONTAL_GUTTERS@@"
    },
    "verticalGutters": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'vertical-double'",
          "computed": false
        }, {
          "value": "'vertical'",
          "computed": false
        }, {
          "value": "'vertical-three-quarters'",
          "computed": false
        }, {
          "value": "'vertical-half'",
          "computed": false
        }, {
          "value": "'vertical-quarter'",
          "computed": false
        }]
      },
      "required": false,
      "description": "{const} One of: @@Grid.Group.VERTICAL_GUTTERS@@, @@Grid.Group.DOUBLE_VERTICAL_GUTTERS@@, @@Grid.Group.THREE_QUARTERS_VERTICAL_GUTTERS@@, @@Grid.Group.HALF_VERTICAL_GUTTERS@@, @@Grid.Group.QUARTER_VERTICAL_GUTTERS@@"
    },
    "fullHeight": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};